import { isProduction, isTesting } from "@web-monorepo/environment";
import { makeSafeStorageWrapper } from "./makeSafeStorageWrapper";
import { getBrowserStorage } from "./getBrowserStorage";

export const localStorage = makeSafeStorageWrapper("local", getBrowserStorage("local"), isProduction || isTesting);
